import React from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import Select from "react-select";
import {
  CreateBanner,
  GetProductStatus,
  GetWedgetTitle,
} from "../apiconfig/authService";

function AddBanner(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;

  const [mediaTitle, setMediaTitle] = useState("");
  const [mediaImage, setMediaImage] = useState(null);
  const [statusid, setStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);
  const [serialNumber, setSerialNumber] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [sliderData, setSliderData] = useState([]);
  const [totalSliders, setTotalSliders] = useState(0);
  const [message, setMessage] = useState("");
  const [refetchData, setRefetchData] = useState(false);

  const [widget, setWidget] = useState();
  const [isMessageRed, setIsMessageRed] = useState("");

  const handleTitleChange = (e) => {
    setMediaTitle(e.target.value);
  };
  const handleSerialNUmber = (e) => {
    setSerialNumber(e.target.value);
  };

  // console.log('mediaImage',mediaImage)
  const handleImageChange = (e) => {
    setMediaImage(e.target.files[0]);
  };

  const handleStatusIdChange = (e) => {
    setStatusid(e.target.value);
  };
  const handleWidgetChange = (e) => {
    setWidget(e.target.value);
  };

  const validateInput = () => {
    if (mediaTitle === "") throw new Error("Name is required.");
    if (mediaImage === null) throw new Error("Image is required.");
  };
  useEffect(() => {
    (async () => {
      try {
        const sliderResponse = await GetWedgetTitle(
          page,
          itemsPerPage,
          search,
          localStorage.getItem("accessToken")
        );
        setSliderData(sliderResponse.data.items);
        console.log("GetWedgetTitle.data?????????", sliderResponse.data);
        setPageCount(Math.ceil(sliderResponse.data.pagination.pageCount));
        setTotalSliders(sliderResponse.data.pagination.count);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, itemsPerPage, refetchData]);

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    const formData = new FormData();
    formData.append("title", mediaTitle);
    formData.append("Image", mediaImage);
    formData.append("statusid", statusid);
    formData.append("serialNumber", serialNumber);

    // Add each selected widget ID
    widget.forEach((id) => formData.append("widgets[]", id));

    try {
      const response = await CreateBanner(
        formData,
        localStorage.getItem("accessToken")
      );

      if (response.status === 201) {
        setMediaTableViewMessage(response.data.message);
        navigate("/banner");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Banner</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/banner" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "black" }}
            className="alert alert-primary"
            role="alert"
          >
            {message}
          </div>
        )}

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catName">Title </label>
              <input
                type="text"
                value={mediaTitle}
                onChange={handleTitleChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Title"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catImg">Image</label>
              <input
                type="file"
                className="form-control custom-input my-2"
                onChange={handleImageChange}
                id="catImg"
                placeholder="Image"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Status</label>
              <select
                className="form-select custom-input my-2"
                onChange={handleStatusIdChange}
                value={statusid}
              >
                {statusData?.map((item) => (
                  <option value={item.statusid}>{item.status}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catName">Serial Number</label>
              <input
                type="text"
                value={serialNumber}
                onChange={handleSerialNUmber}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Serial"
              />
            </div>
          </div>
          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <label htmlFor="floatingInput">Widgets</label>
            {/* <select
              className="form-select"
              onChange={(e) =>
                setWidget([...e.target.selectedOptions].map((o) => o.value))
              }
              value={widget} // Bind selected values to state
              isMulti 
            >
              {sliderData?.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.title}
                </option>
              ))}
            </select> */}
            <Select
              isMulti
              options={sliderData.map((item) => ({
                value: item._id,
                label: item.title,
              }))} // Convert sliderData to options
              onChange={(selectedOptions) => {
                setWidget(selectedOptions.map((option) => option.value)); // Extract selected IDs
              }}
              value={sliderData
                .filter((item) => widget?.includes(item._id))
                .map((item) => ({ value: item._id, label: item.title }))} // Map selected widgets to value format
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button
                type="submit"
                onClick={handleSubmitClick}
                className="btn btn-primary save-btn text-uppercase px-4 my-3"
              >
                Add
              </button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddBanner;
